import { MainArea, Page } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { TemplatesListProvider } from './context/UseTemplatesListContext';
import TemplatesList from './TemplatesList';

export const TemplateListPage: React.FC = () => (
  <TemplatesListProvider>
    <MainArea>
      <AppTopBar />
      <Page>
        <TemplatesList />
      </Page>
    </MainArea>
  </TemplatesListProvider>
);

export default TemplateListPage;
